import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { deleteFavouriteStations as deleteFavouriteStationsOperation } from '../operations/deleteFavouriteStations';

import { STATUS_LOADING } from 'common/constants';

export const deleteFavouriteStations = (builder: ActionReducerMapBuilder<StationsState>) => builder
  .addCase(deleteFavouriteStationsOperation.pending, (state) => {
    state.favouriteStations.deletingStatus = STATUS_LOADING.load;
  })
  .addCase(deleteFavouriteStationsOperation.fulfilled, (state, { payload: { favouriteStationCodes } }) => {
    state.favouriteStations.deletingStatus = STATUS_LOADING.done;
    state.favouriteStations.data = state.favouriteStations.data?.reduce((acc, favouriteStation) => {
      if (favouriteStationCodes.find(stationCodes => stationCodes.toString() === favouriteStation.stationCode.toString())) {
        return acc;
      }

      acc?.push(favouriteStation);
      return acc;
    }, [] as StationsState['favouriteStations']['data']);
  })
  .addCase(deleteFavouriteStationsOperation.rejected, (state) => {
    state.favouriteStations.deletingStatus = STATUS_LOADING.error;
  });
